export default __webpack_public_path__ + "img/seoul_mixer-37ef31a350f21307c88a06704f4cdbf1.png";